module.exports = __webpack_public_path__ + "img/eyes_in_a_bush.801e6244.jpg";